import React from 'react';
import { useParams } from 'react-router-dom';

import { SiteConfigManager, useCategoryState } from '@atlas/core';
import {
  DropdownSkeleton,
  SimpleTournamentSkeleton,
  TournamentBreadcrumbSkeleton,
} from '@atlas/ui';

const SimplifiedViewLoader = ({ children }) => {
  const { tournamentName } = useParams();
  const { initialized, loading } = useCategoryState();

  const isEnableFavouritesInSimplified = SiteConfigManager.getConfig(
    'config.config.sportsbook.enableFavouritesInSimplified',
  );

  if (!tournamentName) return children;

  if (!initialized && loading) {
    return (
      <>
        <div className="simplified-tournament-header-skeleton">
          <TournamentBreadcrumbSkeleton />
        </div>
        <div className="simple-filters-skeleton">
          <DropdownSkeleton />
        </div>
        <SimpleTournamentSkeleton
          minimized
          outcomesNumber={1}
          withFavorite={isEnableFavouritesInSimplified && tournamentName}
        />
      </>
    );
  }

  return children;
};

export default SimplifiedViewLoader;
